import { Box } from '@mui/material'
import cx from 'classnames'

import { useChart } from './hooks/useChart'
import ChartLine from './components/ChartLine'
import Spinner from '../../../../Spinner'
import CustomSelectV2 from '../../../../Form/CustomSelectV2'
import useStyles from './style'

const Chart = () => {
  const { isFetching, chartData, isDecreased, selected, options, mainLabel, onSelectChange, isRank } = useChart()
  const classes = useStyles()

  if (isFetching)
    return (
      <Box className={classes.box}>
        <Box className={classes.box__inner}>
          <Spinner />
        </Box>
      </Box>
    )

  return (
    <Box className={classes.box}>
      <Box className={classes.box__inner}>
        <Box className={classes.title}>
          <span>{mainLabel}</span>
          <CustomSelectV2 value={selected} options={options} onChange={onSelectChange} background="#F8F8F8" />
        </Box>
        <Box className={classes.chart}>
          <Box>
            <ChartLine data={chartData} decrease={isDecreased} isRank={isRank} />
            {/* {Number.isNaN(comparedValue) && ( */}
            {/*  <Box className={cx(classes.compared, classes.empty)}>No data available</Box> */}
            {/* )} */}
          </Box>
          <Box
            className={cx(classes.compared, {
              // not used now
              // [classes.low]: !isDecreased,
            })}
          >
            <span>7-day averages</span>
            {/* not used now */}
            {/* {!Number.isNaN(comparedValue) && ( */}
            {/*    <> */}
            {/*      <span>{comparedValue.toFixed(2)}</span> */}
            {/*      compared to {chartData.length - 1} weeks ago */}
            {/*    </> */}
            {/*  )} */}
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default Chart
